/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'ELEVATORS_LIFTS_ARE_INSPECTED_REGULARLY',
              'ELEVATOR_S_LOAD_CAPACITY_I_E_NUMBER_OF_PEOPLE_KG_LBS_IS_CLEARLY',
              'ALL_ELEVATORS_HAVE_A_SIGN_WARNING_AGAINST_THEIR_USE_IN_CASES_OF',
              'SAFETY_DEVICES_HAVE_BEEN_FITTED_ON_ELEVATOR_DOORS_TO_PREVENT_TH',
              'ELEVATORS_ARE_WIRED_TO_BE_INOPERABLE_WHEN_ELEVATOR_DOORS_ARE_OP',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_1: valueSchema,
  },
}
